import React, { forwardRef, useId } from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

export const Checkbox = forwardRef(
  (
    {
      label,
      labelAdornment,
      description,
      hint,
      error,
      className,
      id,
      disabled,
      ...props
    },
    ref
  ) => {
    const autoId = useId()
    const inputId = id ?? autoId

    return (
      <label
        className={cx("ui-checkbox", disabled && "is-disabled", className)}
        htmlFor={inputId}
      >
        <input
          ref={ref}
          id={inputId}
          type="checkbox"
          className="ui-checkbox__input"
          disabled={disabled}
          {...props}
        />
        <span>
          <span className="ui-checkbox__label">
            {label}
            {labelAdornment ? (
              <span className="ui-checkbox__label-adornment">
                {labelAdornment}
              </span>
            ) : null}
          </span>
          {description && (
            <span className="ui-checkbox__description">{description}</span>
          )}
          {hint && <span className="ui-hint">{hint}</span>}
          {error && <span className="ui-error">{error}</span>}
        </span>
      </label>
    )
  }
)

Checkbox.displayName = "Checkbox"
